import React, { Fragment } from "react";

import { ShowcaseBlock as Value } from "@reactivated";

import { MediaChooserBlock } from "../MediaChooserBlock";

import styles from "./index.module.scss";

interface Props {
    value: Value;
    id?: string;
}

export const ShowcaseBlock = ({ value, id }: Props) => {
    if (!value.items) return <></>;
    return (
        <div className={styles.root}>
            {value.items.map((item, index) => {
                const key = `${id}-${index}`;
                if (!item.media) return <Fragment key={key} />;
                return (
                    <figure key={key} className={styles.item}>
                        <MediaChooserBlock
                            value={item.media}
                            wrapperAttrs={{
                                className: styles.mediaWrapper,
                            }}
                            mediaAttrs={{
                                className: styles.media,
                                style: {
                                    aspectRatio:
                                        item.media[0].type === "image"
                                            ? `${item.media[0].value.width} / ${item.media[0].value.height}`
                                            : undefined,
                                },
                            }}
                        />
                        {item.caption && (
                            <figcaption className={styles.caption}>
                                <p>{item.caption}</p>
                            </figcaption>
                        )}
                    </figure>
                );
            })}
        </div>
    );
};
